export default __webpack_public_path__ + "static/banner_5-68b8d93e4bd81922b08d378b1404e58f.webp";